import React, { useState, useEffect } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var ImagerieResult = function ImagerieResult(_ref) {
  var result = _ref.result;
  return /*#__PURE__*/_jsx(_Fragment, {});
};

export default ImagerieResult;